// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LastDataSourceRefreshModel } from 'src/app/_interfaces/pattern-match/last-data-source-refresh-model';
import { TimeFromNowPipe } from 'src/app/modules/shared/pipes/localizedDate.pipe';
import { LinkToXmartComponent } from './linkToXmart/linkToXmart.component';

@Component({
  selector: 'app-lastDataSourceRefreshStatus',
  templateUrl: './lastDataSourceRefreshStatus.component.html',
  styleUrls: ['./lastDataSourceRefreshStatus.component.css'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [NgIf, LinkToXmartComponent, TranslateModule, TimeFromNowPipe],
})
export class LastDataSourceRefreshStatusComponent {
  @Input() lastDataSourceRefreshState?: LastDataSourceRefreshModel;
  @Input() labelStatusHeader?: string;
  @Input() lastPatternHeader?: string;
  @Input() lastUpdateHeader?: string;
  @Input() hideLastUpdate = false;
}
